import { useEffect, useRef, useState } from "react";

import { Box } from "@chakra-ui/react";
// import { getIndividualLoansStats } from "api/individual-user-management";
import {
  IIndividualLoansPayload, // IIndividualLoansStats,
  // IIndividualLoansStatsPayload,
} from "api/individual-user-management/types";
import { ReactComponent as ChevronRightIcon } from "assets/icons/table-action-chevron-right.svg";
import { useIndividuals } from "contexts/individuals-context";
import {
  individualTableColumnCss, // individualTypeCss,
} from "features/individuals/individuals/styles";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { ROUTES } from "routes/constants";
import {
  capitalizeFirstLetter,
  formatDateTo12HourTime,
  formatDateToDDMMMYYYY,
  handleAmountFormat,
  pluralizeText,
} from "utils";
import { ONE_NAIRA_IN_KOBO, ZERO } from "utils/constants";
import { Maybe } from "utils/general/maybe";

// import { customErrorToast } from "ui/custom-toast";
import Pagination from "ui/pagination";
import { IPaginationData } from "ui/pagination/types";
import { Spinner } from "ui/spinner";
import { Status } from "ui/status";
// import { activeTextToStatus } from "ui/status/const";
import { TStatus } from "ui/status/types";
// import { TStatus } from "ui/status/types";
import Table from "ui/table";
import TableWrapper from "ui/table/table-wrapper";
import { TTableRowData } from "ui/table/types";
import { Heading3, Paragraph3 } from "ui/typography";

import { loansColumns } from "../../../individuals/individuals-list-table/const";
import { DEFAULT_ACCOUNT_TRANSACTIONS_PAGINATION_PARAMS } from "../consts";
import { TableHeaderCTAs } from "./TableHeaderCTAs";
import { TLoanStatus } from "./view-loan-details/LoanStatus";

const statusToTextMap: Record<TStatus, string> = {
  success: "Completed",
  error: "Closed",
  warning: "Running",
  disabled: "Overdue",
  blue: "",
  purple: "",
};
const SelectedLoans = () => {
  const navigate = useNavigate();
  const [isRefreshing, setIsRefreshing] = useState(false);

  const {
    isLoadingIndividualLoans,
    individualLoansResult,
    handleGetIndividualLoans,
  } = useIndividuals();
  const userId = useParams()?.individualId;
  const { data: individualLoans, ...paginationData } =
    individualLoansResult?.loans || {};

  const { loanLimit, loanLimitExpiry, linkedRepaymentMethod } =
    individualLoansResult || {};
  // const [isLoadingIndividualLoansStats, setIsLoadingIndividualLoansStats] =
  //   useState(false);

  // const [individualLoansResultStats, setIndividualLoansResultStats] =
  //   useState<IIndividualLoansStats | null>(null);
  const tableRef = useRef<HTMLTableElement | null>(null);
  const [searchParams] = useSearchParams();
  const page = searchParams.get("page");
  const limit = searchParams.get("limit");
  const tenor = searchParams.get("tenor");
  const status = searchParams.get("status");
  const search = searchParams.get("search");
  const startDate = searchParams.get("startDate");
  const endDate = searchParams.get("endDate");
  const filterRetryCount = searchParams.get("filterRetryCount");
  const [yieldEarnedNaira, yieldEarnedKobo] = handleAmountFormat({
    value: String(
      loanLimit || ZERO / ONE_NAIRA_IN_KOBO
      // individualLoansResultStats?.total || ZERO / ONE_NAIRA_IN_KOBO
    ),
    includeNairaSymbol: true,
    shouldFormatZero: true,
  }).split(".");

  useEffect(() => {
    if (!userId) return;
    const payload: IIndividualLoansPayload = {
      userId,
      page: String(page || DEFAULT_ACCOUNT_TRANSACTIONS_PAGINATION_PARAMS.page),
      limit: String(
        limit || DEFAULT_ACCOUNT_TRANSACTIONS_PAGINATION_PARAMS.limit
      ),
    };

    if (startDate) {
      payload["startDate"] = startDate;
    }

    if (endDate) {
      payload["endDate"] = endDate;
    }

    if (tenor) {
      payload["tenor"] = tenor;
    }

    if (status) {
      const transactionStatus = status.split(",");
      const filteredStatus = transactionStatus
        .filter((transaction) => transaction !== "all")
        .join(",");
      payload["status"] = filteredStatus as TLoanStatus;
    }
    if (search) {
      payload["search"] = search;
      payload["searchBy"] = ["reference"];
    }

    void handleGetIndividualLoans(payload, {
      isRefetching: false,
    });
  }, [
    userId,
    page,
    limit,
    startDate,
    endDate,
    tenor,
    status,
    filterRetryCount,
  ]);

  // console.log({ individualLoans, paginationData, individualLoansResult });

  const handleViewIndividualDetails = (loanRowData: TTableRowData) => {
    const loanId = loanRowData["id"] as string;
    const userId = loanRowData["userId"] as string;
    navigate(
      `${ROUTES.INDIVIDUALS_PAGE}/loans/${loanId}/${userId}/view-loan-details`
    );
  };
  const formattedData =
    individualLoans &&
    individualLoans.map((loan) => {
      const { id, createdAt, amount, tenor, status } = loan;
      let loanStatus: TStatus = "disabled";
      if (status === "paid") {
        loanStatus = "success";
      } else if (status === "closed") {
        loanStatus = "error";
      } else if (status === "disbursed") {
        loanStatus = "warning";
      }

      return {
        "Request Date": (
          <Box>
            <Paragraph3>
              {createdAt ? formatDateToDDMMMYYYY(createdAt) : "N/A"}
            </Paragraph3>
            <p className="uppercase text-sm text-[#807F94]">
              {createdAt ? formatDateTo12HourTime(createdAt) : "N/A"}
            </p>
          </Box>
        ),
        "Loan Amount": (
          <Box
            className="font-semibold text-[#1A202C] text-sm"
            //   css={individualTableColumnCss}
          >
            {amount
              ? handleAmountFormat({
                  value: String(amount / ONE_NAIRA_IN_KOBO),
                  includeNairaSymbol: true,
                  shouldFormatZero: true,
                })
              : "N/A"}
          </Box>
        ),
        Tenor: (
          <Box
            className="font-medium"
            css={individualTableColumnCss}
          >
            {tenor} {pluralizeText("month", tenor, "s")}
          </Box>
        ),
        Disbursement: (
          <Status
            status={status === "disbursed" ? "success" : "disabled"}
            text={status === "disbursed" ? "Successful" : "Not disbursed"}
            className="w-fit"
          />
        ),
        "Loan Status": (
          <Status
            status={loanStatus}
            text={statusToTextMap[loanStatus]}
            className="w-fit"
          />
        ),
        // "Loan Status": (
        //   <Status
        //     status={
        //       getTransationStatus(
        //         status === "approved" ? "successful" : "pending"
        //       ) as TStatus
        //     }
        //     text={status === "approved" ? "Completed" : "Running"}
        //     className="w-fit"
        //   />
        // ),
        "": (
          <Box>
            <ChevronRightIcon />
          </Box>
        ),
        id,
        userId,
      };
    });

  return (
    <div>
      <Box className="flex flex-col gap-4 lg:flex-row lg:gap-[100px] py-4 mb-2 rounded-[20px] bg-white ">
        <Maybe condition={isLoadingIndividualLoans}>
          <Box className="pl-6">
            <Spinner size="30px" />
          </Box>
        </Maybe>
        <Maybe condition={!isLoadingIndividualLoans}>
          <Box className="flex flex-col gap-2 pl-6 pr-4">
            <Paragraph3
              fontSize="14px"
              lineHeight="14px"
              textColor="#718096"
              fontWeight="400"
            >
              Approved Loan Limit
            </Paragraph3>
            <Heading3
              fontSize="20px"
              lineHeight="20px"
              fontWeight="700"
              textColor="#1A202C"
            >
              {yieldEarnedNaira}.
              <span className="text-sm font-[700]">
                {yieldEarnedKobo || "00"}
              </span>
            </Heading3>
          </Box>
          <Box className="flex flex-col gap-2 pl-6 pr-4">
            <Paragraph3
              fontSize="14px"
              lineHeight="14px"
              textColor="#718096"
              fontWeight="400"
            >
              Loan Limit Expiry Date
            </Paragraph3>
            <Paragraph3
              fontSize="14px"
              lineHeight="24px"
              fontWeight="600"
              textColor="#101828"
            >
              {loanLimitExpiry ? formatDateToDDMMMYYYY(loanLimitExpiry) : "N/A"}
            </Paragraph3>
          </Box>
          <Box className="flex flex-col gap-2 pl-6 pr-4">
            <Paragraph3
              fontSize="14px"
              lineHeight="14px"
              textColor="#718096"
              fontWeight="400"
            >
              Linked Repayment Method
            </Paragraph3>
            <Paragraph3
              fontSize="14px"
              lineHeight="24px"
              fontWeight="600"
              textColor="#101828"
            >
              {(linkedRepaymentMethod &&
                (linkedRepaymentMethod === "directdebit"
                  ? "Direct Debit"
                  : capitalizeFirstLetter(linkedRepaymentMethod))) ||
                "N/A"}
            </Paragraph3>
          </Box>
        </Maybe>
      </Box>
      <TableWrapper className="!p-0">
        <TableHeaderCTAs
          handleGetTransactions={handleGetIndividualLoans}
          isLoadingTransactions={isLoadingIndividualLoans}
          isRefreshing={isRefreshing}
          setIsRefreshing={setIsRefreshing}
        />
        <Table
          columns={loansColumns}
          data={formattedData || []}
          onRowClick={handleViewIndividualDetails}
          isRowClickable
          hasCheckbox
          tableRef={tableRef}
          isLoading={isLoadingIndividualLoans}
        />
        <Pagination
          paginationData={paginationData as IPaginationData}
          data={individualLoans || []}
          defaultPaginationParams={
            DEFAULT_ACCOUNT_TRANSACTIONS_PAGINATION_PARAMS
          }
          tableRef={tableRef}
          isLoadingTable={isLoadingIndividualLoans}
        />
      </TableWrapper>
    </div>
  );
};

export default SelectedLoans;
